<template lang="pug">
.generic-wrapper
  .container
    BackButton(name="DataOwners")
    template(v-if="$route.name === 'DataOwnerNew'")
      h1.title Neuer Eigentümer
      .sub-headline Bitte füllen Sie alle erforderlichen Felder aus.
    template(v-if="$route.name === 'DataOwnerEdit' && formData.id")
      h1.title Eigentümer {{ generateOwnerName }}
      .sub-headline Zuletzt bearbeitet am {{ formatDate(formData.updatedAt) }} Uhr

    .guest-wrapper.margin-top
      b-tabs(type="is-boxed", position="is-centered")
        b-tab-item(label="Stammdaten", icon="text-box-outline")
          .two-column
            .column
              .card
                .top
                  .left
                    .card-headline Daten
                    .card-description Hier finden Sie den kompletten Datensatz des Eigentümers.
                  .right
                .main.padding
                  ValidationObserver(v-slot="{ handleSubmit }")
                    .form
                      h2.title.is-6 Allgemein

                      ValidationProvider(
                        name="Eigentümer",
                        rules="required",
                        v-slot="{ errors, valid }"
                      ) 
                        b-field(
                          label="Eigentümer",
                          label-position="on-border",
                          :type="{ 'is-danger': errors[0] }",
                          :message="errors"
                        )
                          b-input(v-model="formData.fullName")

                      ValidationProvider(
                        name="USt - IdNr.",
                        rules="required",
                        v-slot="{ errors, valid }"
                      ) 
                        b-field(
                          label="USt - IdNr.",
                          label-position="on-border",
                          :type="{ 'is-danger': errors[0] }",
                          :message="errors"
                        )
                          b-input(v-model="formData.vatId")

                      ValidationProvider(
                        name="Steuernummer",
                        rules="required",
                        v-slot="{ errors, valid }"
                      ) 
                        b-field(
                          label="Steuernummer",
                          label-position="on-border",
                          :type="{ 'is-danger': errors[0] }",
                          :message="errors"
                        )
                          b-input(v-model="formData.taxId")

                      //- ValidationProvider(
                      //-   name="E-Mail bei neuer Buchung",
                      //-   rules="required",
                      //-   v-slot="{ errors, valid }"
                      //- ) 
                      //-   b-field(
                      //-     :type="{ 'is-danger': errors[0] }",
                      //-     :message="errors"
                      //-   )
                      //-     b-switch(
                      //-       v-model="formData.activeNotification",
                      //-       type="is-success",
                      //-       size="is-small"
                      //-     ) E-Mail bei neuer Buchung

                      ValidationProvider(
                        name="Rechnungen ohne Umsatzsteuer ausweisen",
                        rules="required",
                        v-slot="{ errors, valid }"
                      ) 
                        b-field(
                          :type="{ 'is-danger': errors[0] }",
                          :message="errors"
                        )
                          b-switch(
                            v-model="formData.noTax",
                            type="is-success",
                            size="is-small"
                          ) Rechnungen ohne Umsatzsteuer ausweisen

                    .form.margin-top
                      b-tabs
                        b-tab-item(label="#1", icon="clipboard-account")
                          .card
                            .main.padding
                              ValidationProvider(
                                name="Anrede",
                                rules="required",
                                v-slot="{ errors, valid }"
                              ) 
                                b-field(
                                  label="Anrede",
                                  label-position="on-border",
                                  :type="{ 'is-danger': errors[0] }",
                                  :message="errors"
                                )
                                  b-select(
                                    v-model="formData.ownerOneSalutation"
                                  )
                                    option(value="Frau") Frau
                                    option(value="Herr") Herr
                              ValidationProvider(
                                name="Titel",
                                rules="",
                                v-slot="{ errors, valid }"
                              ) 
                                b-field(
                                  label="Titel",
                                  label-position="on-border",
                                  :type="{ 'is-danger': errors[0] }",
                                  :message="errors"
                                )
                                  b-input(v-model="formData.ownerOneTitle")
                              ValidationProvider(
                                name="Vorname",
                                rules="required",
                                v-slot="{ errors, valid }"
                              ) 
                                b-field(
                                  label="Vorname",
                                  label-position="on-border",
                                  :type="{ 'is-danger': errors[0] }",
                                  :message="errors"
                                )
                                  b-input(v-model="formData.ownerOneFirstName")
                              ValidationProvider(
                                name="Nachname",
                                rules="required",
                                v-slot="{ errors, valid }"
                              ) 
                                b-field(
                                  label="Nachname",
                                  label-position="on-border",
                                  :type="{ 'is-danger': errors[0] }",
                                  :message="errors"
                                )
                                  b-input(v-model="formData.ownerOneLastName")
                        b-tab-item(label="#2", icon="clipboard-account")
                          .card
                            .main.padding
                              ValidationProvider(
                                name="Anrede",
                                rules="",
                                v-slot="{ errors, valid }"
                              ) 
                                b-field(
                                  label="Anrede",
                                  label-position="on-border",
                                  :type="{ 'is-danger': errors[0] }",
                                  :message="errors"
                                )
                                  b-select(
                                    v-model="formData.ownerTwoSalutation"
                                  )
                                    option(value="Frau") Frau
                                    option(value="Herr") Herr
                              ValidationProvider(
                                name="Titel",
                                rules="",
                                v-slot="{ errors, valid }"
                              ) 
                                b-field(
                                  label="Titel",
                                  label-position="on-border",
                                  :type="{ 'is-danger': errors[0] }",
                                  :message="errors"
                                )
                                  b-input(v-model="formData.ownerTwoTitle")
                              ValidationProvider(
                                name="Vorname",
                                rules="",
                                v-slot="{ errors, valid }"
                              ) 
                                b-field(
                                  label="Vorname",
                                  label-position="on-border",
                                  :type="{ 'is-danger': errors[0] }",
                                  :message="errors"
                                )
                                  b-input(v-model="formData.ownerTwoFirstName")
                              ValidationProvider(
                                name="Nachname",
                                rules="",
                                v-slot="{ errors, valid }"
                              ) 
                                b-field(
                                  label="Nachname",
                                  label-position="on-border",
                                  :type="{ 'is-danger': errors[0] }",
                                  :message="errors"
                                )
                                  b-input(v-model="formData.ownerTwoLastName")
                        b-tab-item(label="#3", icon="clipboard-account")
                          .card
                            .main.padding
                              ValidationProvider(
                                name="Anrede",
                                rules="",
                                v-slot="{ errors, valid }"
                              ) 
                                b-field(
                                  label="Anrede",
                                  label-position="on-border",
                                  :type="{ 'is-danger': errors[0] }",
                                  :message="errors"
                                )
                                  b-select(
                                    v-model="formData.ownerThreeSalutation"
                                  )
                                    option(value="Frau") Frau
                                    option(value="Herr") Herr
                              ValidationProvider(
                                name="Titel",
                                rules="",
                                v-slot="{ errors, valid }"
                              ) 
                                b-field(
                                  label="Titel",
                                  label-position="on-border",
                                  :type="{ 'is-danger': errors[0] }",
                                  :message="errors"
                                )
                                  b-input(v-model="formData.ownerThreeTitle")
                              ValidationProvider(
                                name="Vorname",
                                rules="",
                                v-slot="{ errors, valid }"
                              ) 
                                b-field(
                                  label="Vorname",
                                  label-position="on-border",
                                  :type="{ 'is-danger': errors[0] }",
                                  :message="errors"
                                )
                                  b-input(
                                    v-model="formData.ownerThreeFirstName"
                                  )
                              ValidationProvider(
                                name="Nachname",
                                rules="",
                                v-slot="{ errors, valid }"
                              ) 
                                b-field(
                                  label="Nachname",
                                  label-position="on-border",
                                  :type="{ 'is-danger': errors[0] }",
                                  :message="errors"
                                )
                                  b-input(
                                    v-model="formData.ownerThreeLastName"
                                  )

                    .form.margin-top
                      h2.title.is-6 Adresse

                      //- b-field(label="Eigentümerbezeichnung" label-position="on-border")
                      //-   b-input(v-model="formData.address.line1")

                      ValidationProvider(
                        name="Straße und HausNr.",
                        rules="required",
                        v-slot="{ errors, valid }"
                      ) 
                        b-field(
                          label="Straße und HausNr.",
                          label-position="on-border",
                          :type="{ 'is-danger': errors[0] }",
                          :message="errors"
                        )
                          b-input(v-model="formData.address.street")

                      b-field(grouped)
                        ValidationProvider(
                          name="PLZ",
                          rules="required",
                          v-slot="{ errors, valid }"
                        ) 
                          b-field(
                            label="PLZ",
                            label-position="on-border",
                            :type="{ 'is-danger': errors[0] }",
                            :message="errors"
                          )
                            b-input(v-model="formData.address.zip")
                        .spacer.sm
                        ValidationProvider(
                          name="Stadt",
                          rules="required",
                          v-slot="{ errors, valid }"
                        ) 
                          b-field(
                            label="Stadt",
                            label-position="on-border",
                            :type="{ 'is-danger': errors[0] }",
                            :message="errors"
                          )
                            b-input(v-model="formData.address.city")

                      ValidationProvider(
                        name="Land",
                        rules="required",
                        v-slot="{ errors, valid }"
                      ) 
                        b-field(
                          label="Land",
                          label-position="on-border",
                          :type="{ 'is-danger': errors[0] }",
                          :message="errors"
                        )
                          b-input(v-model="formData.address.country")

                      .margin-top
                        h2.title.is-6 Kontakt
                        ValidationProvider(
                          name="E-Mail",
                          rules="required|email",
                          v-slot="{ errors, valid }"
                        ) 
                          b-field(
                            label="E-Mail",
                            label-position="on-border",
                            :type="{ 'is-danger': errors[0] }",
                            :message="errors"
                          )
                            b-input(v-model="formData.address.email")
                        ValidationProvider(
                          name="Alternative E-Mail",
                          rules="email",
                          v-slot="{ errors, valid }"
                        ) 
                          b-field(
                            label="Alternative E-Mail",
                            label-position="on-border",
                            :type="{ 'is-danger': errors[0] }",
                            :message="errors"
                          )
                            b-input(v-model="formData.address.email2")
                        ValidationProvider(
                          name="Mobiltelefon",
                          rules="required",
                          v-slot="{ errors, valid }"
                        ) 
                          b-field(
                            label="Mobiltelefon",
                            label-position="on-border",
                            :type="{ 'is-danger': errors[0] }",
                            :message="errors"
                          )
                            b-input(v-model="formData.address.mobile")
                        ValidationProvider(
                          name="Telefon",
                          rules="",
                          v-slot="{ errors, valid }"
                        ) 
                          b-field(
                            label="Telefon",
                            label-position="on-border",
                            :type="{ 'is-danger': errors[0] }",
                            :message="errors"
                          )
                            b-input(v-model="formData.address.phone")
                        ValidationProvider(
                          name="Telefax",
                          rules="",
                          v-slot="{ errors, valid }"
                        ) 
                          b-field(
                            label="Telefax",
                            label-position="on-border",
                            :type="{ 'is-danger': errors[0] }",
                            :message="errors"
                          )
                            b-input(v-model="formData.address.fax")

                    .form.margin-top
                      h2.title.is-6 Bankdaten
                      ValidationProvider(
                        name="Kontoinhaber",
                        rules="required",
                        v-slot="{ errors, valid }"
                      ) 
                        b-field(
                          label="Kontoinhaber",
                          label-position="on-border",
                          :type="{ 'is-danger': errors[0] }",
                          :message="errors"
                        )
                          b-input(v-model="formData.accountOwner")
                      ValidationProvider(
                        name="Bank",
                        rules="required",
                        v-slot="{ errors, valid }"
                      ) 
                        b-field(
                          label="Bank",
                          label-position="on-border",
                          :type="{ 'is-danger': errors[0] }",
                          :message="errors"
                        )
                          b-input(v-model="formData.bankName")
                      ValidationProvider(
                        name="IBAN",
                        rules="required",
                        v-slot="{ errors, valid }"
                      ) 
                        b-field(
                          label="IBAN",
                          label-position="on-border",
                          :type="{ 'is-danger': errors[0] }",
                          :message="errors"
                        )
                          b-input(v-model="formData.iban")
                      ValidationProvider(
                        name="BIC",
                        rules="required",
                        v-slot="{ errors, valid }"
                      ) 
                        b-field(
                          label="BIC",
                          label-position="on-border",
                          :type="{ 'is-danger': errors[0] }",
                          :message="errors"
                        )
                          b-input(v-model="formData.bic")

                    .form.margin-top
                      b-field(
                        label="Kommentar zum Eigentümer",
                        label-position="on-border"
                      )
                        b-input(type="textarea", v-model="formData.comment")

                    .button-wrapper.margin-top.right
                      b-button(
                        type="is-light",
                        @click="$router.push({ name: 'DataOwners' })"
                      ) Abbrechen
                      b-button(
                        type="is-primary",
                        @click="handleSubmit(updateOwner)"
                      ) Speichern

            .column
              .card(v-if="$route.name === 'DataOwnerEdit' && formData.id")
                .top
                  .left
                    .card-headline Objekte
                    .card-description Hier finden Sie alle Objekte des Eigentümers.
                  .right
                .main.padding
                  b-table(
                    :data="formData.rentObjects",
                    default-sort-direction="asc",
                    default-sort="date",
                    hoverable,
                    @click="(row) => $router.push('/data/rent-objects/edit/' + row.id)"
                  )
                    b-table-column(
                      field="thumbnail",
                      label="Vorschau",
                      v-slot="props"
                    )
                      img(
                        :src="props.row.rentObjectImages[0] ? props.row.rentObjectImages[0].thumbnailUrl : 'https://via.placeholder.com/150'"
                      )
                    b-table-column(
                      field="name",
                      label="Mietobjekt",
                      sortable,
                      v-slot="props"
                    )
                      .r-name {{ props.row.name }}

        b-tab-item(
          label="Abrechnungen",
          icon="file-document-outline",
          :disabled="$route.name === 'DataOwnerNew'"
        )
          OwnerSettlements(
            v-if="$route.name === 'DataOwnerEdit'",
            :id="id",
            :owner="owner",
            :createdAt="owner ? new Date(owner.createdAt) : new Date()"
          )
</template>

<script>
import { DateTime } from "luxon";
import OwnerSettlements from "@/components/organisms/OwnerSettlements.vue";

export default {
  components: {
    OwnerSettlements,
  },
  props: {
    id: {
      type: [Number, String],
      default: null,
    },
  },
  data() {
    return {
      owner: null,
      formData: {
        fullName: null,
        taxId: null,
        vatId: null,
        bankName: null,
        accountOwner: null,
        iban: null,
        bic: null,
        activeNotification: false,
        noTax: false,
        comment: "",
        address: {
          line1: null,
          line2: null,
          street: null,
          zip: null,
          city: null,
          country: "Deutschland",
          email: null,
          phone: null,
          mobile: null,
          fax: null,
        },
        ownerOneSalutation: null,
        ownerOneTitle: null,
        ownerOneFirstName: null,
        ownerOneLastName: null,
        ownerTwoSalutation: null,
        ownerTwoTitle: null,
        ownerTwoFirstName: null,
        ownerTwoLastName: null,
        ownerThreeSalutation: null,
        ownerThreeTitle: null,
        ownerThreeFirstName: null,
        ownerThreeLastName: null,
      },
    };
  },
  computed: {
    generateOwnerName() {
      let names = [];

      if (this.formData.ownerOneSalutation && this.formData.ownerOneLastName) {
        names.push(
          `${this.formData.ownerOneSalutation}${
            this.formData.ownerOneTitle ? " " + this.formData.ownerOneTitle : ""
          } ${this.formData.ownerOneLastName}`
        );
      }

      if (this.formData.ownerTwoSalutation && this.formData.ownerTwoLastName) {
        const ownerName = `${this.formData.ownerTwoSalutation}${
          this.formData.ownerTwoTitle ? " " + this.formData.ownerTwoTitle : ""
        } ${this.formData.ownerTwoLastName}`;
        if (this.formData.ownerTwoSalutation === "Frau") {
          names.unshift(ownerName);
        } else {
          names.push(ownerName);
        }
      }

      if (
        this.formData.ownerThreeSalutation &&
        this.formData.ownerThreeLastName
      ) {
        const ownerName = `${this.formData.ownerThreeSalutation}${
          this.formData.ownerThreeTitle
            ? " " + this.formData.ownerThreeTitle
            : ""
        } ${this.formData.ownerThreeLastName}`;
        if (this.formData.ownerThreeSalutation === "Frau") {
          names.unshift(ownerName);
        } else {
          names.push(ownerName);
        }
      }

      return names.join(", ");
    },
  },
  async mounted() {
    this.mount();
  },
  methods: {
    async mount() {
      const loadingComponent = this.$buefy.loading.open();

      if (this.$route.name === "DataOwnerEdit" && this.id) {
        this.owner = await this.$store.dispatch("owners/findOne", {
          id: this.id,
        });
        this.formData = {
          ...this.formData,
          ...this.owner,
        };
      }
      loadingComponent.close();
    },
    async updateOwner() {
      if (this.id) {
        await this.$store.dispatch("owners/update", this.formData);
      } else {
        await this.$store.dispatch(
          "owners/create",
          this.formData
        );
        this.$router.push({
          name: "DataOwners"
        });
      }
    },
    formatDate(d) {
      const dt = DateTime.fromISO(d);
      return dt.toLocaleString({
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
      });
    },
    simpleDate(d) {
      const dt = DateTime.fromISO(d);
      return dt.toLocaleString({
        year: "numeric",
        month: "short",
        day: "numeric",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.status-wrapper {
  margin-top: $xs-space;
}

.button-wrapper {
  margin: $xs-space 0 $sm-space 0;
}
.two-column {
  display: flex;
  justify-content: space-between;
}
.r-name {
  font-weight: 500;
}
.label {
  font-weight: 600;
  margin-top: $sm-space;
  margin-bottom: 0;
  &:not(:last-child) {
    margin-bottom: 0;
  }
}
</style>